import { ContratoRenegociacaoItem, Proponente } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from '../comum/exercicio.model';
import { Usuario } from '../comum/usuario.model';
import { Contrato } from './contrato.model';

export class ContratoRenegociacao extends BaseResourceModel {
  constructor(
    public motivo?: string,
    public data_renegociacao?: Date,
    public data_contabilizacao?: Date,
    public valor_total_enviado?: number,
    public valor_total_recebido?: number,
    public contrato_enviado?: Contrato,
    public contrato_recebido?: Contrato,
    public usuario?: Usuario,
    public exercicio?: Exercicio,
    public itens?: ContratoRenegociacaoItem[],
    public editavel?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): ContratoRenegociacao {
    return Object.assign(new ContratoRenegociacao(), json);
  }
}
